import React from "react";
import { AMENITY_CATEGORIES } from "@/lib/amenities";

/**
 * AmenitiesPicker — checkboxes grouped by category.
 * value: string[] (selected amenity keys)
 * onChange: (newValue: string[]) => void
 */
export default function AmenitiesPicker({ value = [], onChange }) {
  const selected = new Set(value);

  const toggle = (key) => {
    const next = new Set(selected);
    if (next.has(key)) next.delete(key);
    else next.add(key);
    onChange(Array.from(next));
  };

  return (
    <div className="space-y-6" data-testid="amenities-picker">
      {AMENITY_CATEGORIES.map((cat) => {
        const Icon = cat.icon;
        return (
          <div key={cat.key} className="border border-black/10 bg-white">
            <div className="flex items-center gap-2 px-4 py-3 border-b border-black/10 bg-[#FAFAFA]">
              <Icon className="w-4 h-4" />
              <div className="text-[11px] uppercase tracking-[0.25em] font-bold">{cat.label}</div>
            </div>
            <div className="p-4 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-2">
              {cat.items.map((it) => {
                const checked = selected.has(it.key);
                return (
                  <button
                    key={it.key}
                    type="button"
                    data-testid={`amenity-${it.key}`}
                    onClick={() => toggle(it.key)}
                    className={`flex items-center gap-2 px-3 py-2 text-left text-xs border transition-colors ${
                      checked
                        ? "bg-[#0A0A0A] text-white border-[#0A0A0A]"
                        : "bg-white border-black/15 hover:border-[#0A0A0A]"
                    }`}
                  >
                    <span className={`w-3.5 h-3.5 inline-block border ${checked ? "bg-white border-white" : "border-black/30"}`}>
                      {checked && <span className="block w-full h-full bg-white relative">
                        <span className="absolute inset-0 flex items-center justify-center text-[10px] text-[#0A0A0A] font-bold">✓</span>
                      </span>}
                    </span>
                    <span className="truncate">{it.label}</span>
                  </button>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
}
